import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

type Space = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
type Align = "start" | "center" | "end" | "stretch";

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  gap?: Space;
  align?: Align;
  children: ReactNode;
}

/**
 * Vertical layout primitive. Uses logical CSS so it works in RTL
 * unchanged (vertical layouts are direction-agnostic; provided here
 * for API symmetry with <Inline>).
 */
export function Stack({ gap = 3, align = "stretch", style, children, ...rest }: StackProps) {
  const computed: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: align === "stretch" ? "stretch" : `flex-${align}`,
    gap: `var(--gt-sys-space-${gap})`,
    ...style,
  };
  return (
    <div {...rest} style={computed}>
      {children}
    </div>
  );
}
